module.exports = __webpack_public_path__ + "static/img/hezuo07.171ecd1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/imgsrc/hezuo07.jpg
// module id = eVMu
// module chunks = 1